module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/edit-eb532f298e92631b480ce52d497e2c04.svg";